import React, { useEffect, useRef, useState } from "react";
import { Item, ComboBox, Grid, useAsyncList, Flex, View } from "@adobe/react-spectrum";
import { useDependency } from "../../../../../contexts/DependencyProvider";
import { GetContactListRequest } from "../../../../../services/soap/main/requests/GetContactListRequest";
import { useTranslation } from "react-i18next";


export interface Character {
    id:number;
    name1: string;
    name2: string;
    name3: string;
}

interface IPersonDropdownProps{
   selectedPerson:string;
   onChange:(data:Character,index:number,mode:string)=> void;
   isDisabled:boolean;
   width:string
   contacType:string //p for Person and c for Company
   focused?:boolean;
   isShowLabel?:boolean
}

const PersonDropdown:React.FC<IPersonDropdownProps> = ({
  selectedPerson,
  onChange,
  isDisabled,
  width,
  contacType,
  focused,
  isShowLabel}) => {
  const { store, mainService } = useDependency();
  const [selectedKey, setSelectedKey] = useState<string | null>(null);
  const firstInputRef = useRef<any>(null);
  const { t } = useTranslation('contacts');
  const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
  useEffect(()=>{
     list.reload();
      if (firstInputRef.current) {
          firstInputRef.current.focus();
        }
  },[])

  useEffect(() => {
    if (firstInputRef.current && focused) {
      firstInputRef.current.focus();
    }
  }, [focused]);

  useEffect(() => {
    if (selectedPerson) {
        setSelectedKey(selectedPerson);
        list.reload();
    } else {
      setSelectedKey(null);
    }
  }, [selectedPerson]);

  const list = useAsyncList<Character>({
    async load({ cursor,filterText }) {
      const offset = cursor ? Number(cursor) : 0;
      const limit = 500;
      try {
        const request = new GetContactListRequest(
          store.Server, store.SessionId, 
          { limit, offset,type: contacType === 'p' ? 1 : 0,contains:`*${filterText}`});
        const response = await mainService.getContactList(request);

        const companies = response?.CONTACT || [];
        if (!Array.isArray(companies)) {
          console.error("Invalid API response: Expected an array", response);
          return { items: [] };
        }

        return {
          items: companies,
          cursor: companies.length === limit ? String(offset + limit) : undefined,
        };
      } catch (error) {
        console.error("Error fetching companies:", error);
        return { items: [] };
      }
    },
  });


  const handleSelectionChange = (key:any) => {
    setSelectedKey(key);
    if (key) {
      const selectedCompany = list.items.find((x) => x.id === key);
      if (selectedCompany) {
        onChange(selectedCompany,0,"add");
      }
    }
  };

  return (
    <ComboBox
      ref={firstInputRef}
      label={isShowLabel?contacType === 'p'? _tt("persons") : _tt("companies"):""}
      items={list.items}
      onLoadMore={list.loadMore}
      selectedKey={selectedKey}
      onSelectionChange={handleSelectionChange}
      width={{base:'100%',L:width}}
      isDisabled={isDisabled}
      onInputChange={list.setFilterText}
    > 
  {(item) => (
    <Item key={item.id} textValue={`${item.name1} ${item.name3}`}>
      {`${item.name3 ? item.name3 : ''} ${item.name1 ? item.name1 : ''}`}
    </Item>
  )}
</ComboBox>
  );
};

export default PersonDropdown;
